import {Injectable} from "@angular/core";
import {HttpService} from "../../../core/shared/http.service";
import {NzMessageService} from "ng-zorro-antd/message";
import {FuseConfirmationService} from "../../../../@fuse/services/confirmation";
import {BehaviorSubject, take} from "rxjs";

import {HttpStatusCode} from "@angular/common/http";
import {MemberInfo} from "../../secure-url/secure-url.types";
import {parseDomain, ParseResultType} from "parse-domain";

@Injectable({
    providedIn: 'root'
})
export class SignInService {

    private _memberInfo: BehaviorSubject<MemberInfo | null> = new BehaviorSubject(null);

    constructor(
        private _http: HttpService,
        private _messageService: NzMessageService,
        private _fuseConfirmationService: FuseConfirmationService,
    ) {
    }

    get memberInfo$(): BehaviorSubject<MemberInfo | null> {
        return this._memberInfo;
    }

    public async getMemberInfo(domain: string) {
        const hostname = window.location.hostname;

        console.log("Hostname: ", hostname);

        /* Function to parse the root domain */
        const getMainDomain = (hostname: string): string | null => {
            const parseResult = parseDomain(hostname);

            console.log("Parse result: ", parseResult);

            if (parseResult.type === ParseResultType.Listed) {
                const {domain, topLevelDomains} = parseResult;
                return `${domain}.${topLevelDomains.join('.')}`;
            } else if (parseResult.type === ParseResultType.Reserved) {
                return `${parseResult.hostname}`
            }

            return null;
        };

        /* Get the main domain */
        const rootDomain = getMainDomain(hostname);

        const params = {target: rootDomain};

        try {
            const response = await this._http.get<any>(`/v1/member-client/get-member-info`, params)
                .pipe(take(1))
                .toPromise();

            if (+response.code === HttpStatusCode.Ok) {
                this._memberInfo.next(response.data);
                return response.data;
            } else {
                this._messageService.error(response.message, {nzDuration: 5000});
                return null;
            }
        } catch (error) {
            this._fuseConfirmationService.open({
                title: "",
                message: error.message,
                actions: {
                    confirm: {
                        show: false
                    },
                    cancel: {
                        label: 'OK'
                    }
                }
            });

            throw new Error("Failed to get auth company info.");
        }
    }

    public generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
